import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryBrowse() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">分类浏览</h2>
          <p className="text-sm text-foreground-500 mt-3">探索你感兴趣的短视频内容领域</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300/40 transition-all cursor-pointer hover:-translate-y-1"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 font-heading">{cat.name}</h3>
                <p className="text-xs text-foreground-400">{cat.count.toLocaleString()} 个视频</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}